export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_BANCA_BM-a6a02105a529d397c3dd7f04aca3a554.pdf";